import React from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import DragHandle from '@mui/icons-material/DragHandle';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const styles = {
  itemDragging: {
    background: 'blanchedalmond',
  },
};

class DroppableImageList extends React.Component {
  handleDragEnd = result => {
    if (!result.destination) {
      // Dropped somewhere it doesn't belong
      return;
    }
    // images are displayed in reverse order, so we have to reverse the indexes back
    const oldIndex = this.props.imageNames.length - 1 - result.source.index;
    const newIndex = this.props.imageNames.length - 1 - result.destination.index;
    this.props.onDragEnd(this.reorder(this.props.imageNames, oldIndex, newIndex));
  };

  reorder = (list, oldIndex, newIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(oldIndex, 1);
    result.splice(newIndex, 0, removed);

    return result;
  };

  render() {
    return (
      <DragDropContext onDragEnd={this.handleDragEnd}>
        <Droppable droppableId="layers" direction="vertical">
          {(provided, snapshot) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              <List dense disablePadding>
                {this.props.imageNames
                  .slice()
                  .reverse()
                  .map((name, index) => (
                    <React.Fragment key={name + index}>
                      <Draggable draggableId={name} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="glint-hover-lift"
                            style={{
                              ...provided.draggableProps.style,
                              ...(snapshot.isDragging ? styles.itemDragging : {}),
                            }}
                          >
                            <ListItem>
                              <ListItemIcon>
                                <DragHandle />
                              </ListItemIcon>
                              <ListItemText primary={name} />
                            </ListItem>
                          </div>
                        )}
                      </Draggable>
                    </React.Fragment>
                  ))}
              </List>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

DroppableImageList.propTypes = {
  imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  onDragEnd: PropTypes.func,
};

DroppableImageList.defaultProps = {
  onDragEnd() {},
};

export default DroppableImageList;
